export default {
  userIcon: {
    color: `rgb(66, 133, 244)`,
    fontSize: `2.5rem`,
    cursor: `pointer`,
  },
  dropDown: {
    position: `absolute`,
    zIndex: 1,
    minWidth: `165px`,
    backgroundColor: `white`,
    textAlign: `left`,
    padding: `0.5rem 0`,
    margin: `2.5rem 0 0 0rem`,
    right: '0.2rem',
  },
  dropDownItem: {
    lineHeight: `1.6em`,
    paddingLeft: `0.5rem`,
    display: 'flex',
    alignItems: 'center',
  }
};
